export default {
  addOns: '附加项目',
  availability: '可用性',
  availabilityDaySelector: '可用日期选择器',
  unavailable: '不可用',
  person: '人',
  people: '人',
  reserveNow: '立即预订',
  selectTime: '选择时间',
  select: '选择',
  reserve: '预订',
  time: '时间',
  tier: '等级',
  questions: '问题',
  addToCart: '加入购物车',
  checkout: '结账',
  total: '总计',
  whatsIncluded: '包含内容',
  showMore: '显示更多',
  showLess: '收起',
  session: '场次',
  viewDetails: '查看详情',
  findAvailability: '查找可用性',
  loading: '加载中',
  capacity: '容量',
  noAvailableSessionsOnThisDate: '该日期无可用场次',
  noGroupAvailableOnThisDateAndTime: '该日期和时间无可用的 {{groupTitle}}',
  noCollectionFound: '未找到任何合集！',
  noResourceGroupFound: '未找到资源组！',
  noData: '无数据！',
  continue: '继续',
  night: '晚',
  nights: '晚',
  noAvailableSessionsForSelectedDates:
    '您选择的某些日期没有可用场次。请选择其他日期。',
  from: '从',
  dateRangeSelector: '日期范围选择器',
  priceTierRadioGroup: '价格等级选择器',
  startTime: '开始时间',
  duration: '时长',
  lengthOfStay: '入住时长',
  startDate: '开始日期',
  endDate: '结束日期',
  selectDates: '选择日期',
  more: '更多',
  selectStartTime: '选择开始时间',
  endTime: '结束时间',
  selectEndTime: '选择结束时间',
  morning: '上午',
  afternoon: '下午',
  save: '保存',
  selectDuration: '选择时长',
  forLength: '{{length}}',
  moreDates: '还有 {{count}} 个',
  addDate: '添加日期',
  start: '开始',
  end: '结束',
  pickupFrom: '最早取件',
  returnBy: '最晚归还',
  day: '天',
  days: '天',
  hour: '小时',
  hours: '小时',
};
